import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Button } from "@/components/ui/button";
import { STATUS_LABELS, STATUS_COLORS, CATEGORY_LABELS } from "@/lib/constants";
import { Plus, Briefcase, Truck } from "lucide-react";

export default function MyJobs() {
  const [posted, setPosted] = useState([]);
  const [hauled, setHauled] = useState([]);
  const [searchParams, setSearchParams] = useSearchParams();
  const initialTab = searchParams.get("tab") === "hauled" ? "hauled" : "posted";

  useEffect(() => {
    api.get("/jobs", { params: { mine: true } }).then(r => setPosted(r.data));
    api.get("/jobs/driver-jobs").then(r => setHauled(r.data)).catch(() => {});
  }, []);

  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 py-8">
      <div className="flex items-center justify-between mb-6 flex-wrap gap-3">
        <h1 className="text-3xl font-bold">Mine jobs</h1>
        <Link to="/post"><Button className="gap-2"><Plus className="w-4 h-4" /> Opret job</Button></Link>
      </div>

      <Tabs defaultValue={initialTab} onValueChange={(v) => setSearchParams({ tab: v })}>
        <TabsList className="mb-6">
          <TabsTrigger value="posted" data-testid="tab-posted"><Briefcase className="w-4 h-4 mr-2" /> Mine opslag ({posted.length})</TabsTrigger>
          <TabsTrigger value="hauled" data-testid="tab-hauled"><Truck className="w-4 h-4 mr-2" /> Hentede jobs ({hauled.length})</TabsTrigger>
        </TabsList>
        <TabsContent value="posted"><JobList jobs={posted} emptyMsg="Du har ikke oprettet nogen jobs endnu." /></TabsContent>
        <TabsContent value="hauled"><JobList jobs={hauled} emptyMsg="Du har ikke hentet nogen jobs endnu." /></TabsContent>
      </Tabs>
    </div>
  );
}

function JobList({ jobs, emptyMsg }) {
  if (jobs.length === 0) return <Card className="p-12 text-center text-muted-foreground">{emptyMsg}</Card>;
  return (
    <div className="space-y-3">
      {jobs.map(j => (
        <Link key={j.id} to={`/jobs/${j.id}`}>
          <Card className="p-4 hover:shadow-md transition-shadow">
            <div className="flex items-center justify-between gap-4 flex-wrap">
              <div className="min-w-0 flex-1">
                <p className="font-semibold truncate">{j.title}</p>
                <p className="text-xs text-muted-foreground mt-0.5">{CATEGORY_LABELS[j.category]} · {j.pickup_address}</p>
              </div>
              <div className="flex items-center gap-3 shrink-0">
                <Badge variant="outline" className={`${STATUS_COLORS[j.status]} text-xs`}>{STATUS_LABELS[j.status]}</Badge>
                <span className="font-bold text-primary">{j.budget} DKK</span>
              </div>
            </div>
          </Card>
        </Link>
      ))}
    </div>
  );
}
